const minVelocity = 0.01,
    halfPi = Math.PI / 2;

document.addEventListener("DOMContentLoaded", () => {
    AFRAME.registerComponent("character-controller", {
        schema: {
            groundAcc: { default: 5.5 },
            easing: { default: 10 },
            pivot: { type: "selector" },
            bot: { type: "selector" },
            playerRigCamera: { type: "selector", default: "#playerRigCamera" },
            snapRotationDegrees: { default: 45 * THREE.MathUtils.DEG2RAD },
            rotationSpeed: { default: 1 },
            enabled: { default: true },
            rotationForeArmInitial: {
                type: "vec3",
                default: {
                    x: 0,
                    y: 0,
                    z: 0,
                },
            },
            fly: { default: false },
            facemesh: { default: false },
        },
        init: function () {
            this.velocity = new THREE.Vector3(0, 0, 0);
            this.accelerationInput = new THREE.Vector3(0, 0, 0);
            this.pendingSnapRotationMatrix = new THREE.Matrix4();
            this.angularVelocity = 0;
            this.targetAngleEuler = new THREE.Euler();
            this.targetAngle = new THREE.Quaternion();
            this.cameraPositionMatrix = new THREE.Matrix4();
            this.data.eyeNeckOffset;
            this.setAccelerationInput = this.setAccelerationInput.bind(this);
            this.setAccelerationInputStop =
                this.setAccelerationInputStop.bind(this);
            this.snapRotateLeft = this.snapRotateLeft.bind(this);
            this.snapRotateRight = this.snapRotateRight.bind(this);
            this.setAngularVelocity = this.setAngularVelocity.bind(this);
            this.handleTeleport = this.handleTeleport.bind(this);
            this.handleBoostUp = this.handleBoostUp.bind(this);
            this.handleBoostDown = this.handleBoostDown.bind(this);
            this.left = true;
            this.boost = false;
            this._rotationCache = new THREE.Vector3();
            this.inVR =
                this.el.sceneEl.is("vr-mode") &&
                this.el.sceneEl.checkHeadsetConnected();
            this.avatar = this.el.querySelector("#avatar");
            this.pendingSnapRotationMatrix.identity();
            this.clock = new THREE.Clock();
        },
        update: function () {
            // Create left and right rotation matrices for snap rotation based on given degrees
            this.leftRotationMatrix = new THREE.Matrix4().makeRotationY(
                this.data.snapRotationDegrees
            );
            this.rightRotationMatrix = new THREE.Matrix4().makeRotationY(
                -this.data.snapRotationDegrees
            );

            // Check if the application is in VR mode and if a VR headset is connected
            this.inVR =
                this.el.sceneEl.is("vr-mode") &&
                this.el.sceneEl.checkHeadsetConnected();

            // Get the avatar element with the ID '#avatar'
            this.avatar = this.el.querySelector("#avatar");
        },
        play: function () {
            const scene = this.el.sceneEl;
            scene.addEventListener("move", this.setAccelerationInput);
            scene.addEventListener("idle", this.setAccelerationInputStop);
            scene.addEventListener(
                "trackpad_dpad4_up",
                this.setAccelerationInputStop
            );
            scene.addEventListener("w_up", this.setAccelerationInputStop);
            scene.addEventListener("s_up", this.setAccelerationInputStop);
            scene.addEventListener("d_up", this.setAccelerationInputStop);
            scene.addEventListener("a_up", this.setAccelerationInputStop);
            scene.addEventListener("rotateY", this.setAngularVelocity);
            scene.addEventListener("snap_rotate_left", this.snapRotateLeft);
            scene.addEventListener("snap_rotate_right", this.snapRotateRight);
            scene.addEventListener("teleported", this.handleTeleport);
            scene.addEventListener("boost_up", this.handleBoostUp);
            scene.addEventListener("boost_down", this.handleBoostDown);
        },
        pause: function () {
            const scene = this.el.sceneEl;
            scene.removeEventListener("move", this.setAccelerationInput);
            scene.removeEventListener("idle", this.setAccelerationInputStop);
            scene.removeEventListener(
                "trackpad_dpad4_up",
                this.setAccelerationInputStop
            );
            scene.removeEventListener("w_up", this.setAccelerationInputStop);
            scene.removeEventListener("s_up", this.setAccelerationInputStop);
            scene.removeEventListener("d_up", this.setAccelerationInputStop);
            scene.removeEventListener("a_up", this.setAccelerationInputStop);
            scene.removeEventListener("rotateY", this.setAngularVelocity);
            scene.removeEventListener("snap_rotate_left", this.snapRotateLeft);
            scene.removeEventListener(
                "snap_rotate_right",
                this.snapRotateRight
            );
            scene.removeEventListener("teleported", this.handleTeleport);
            scene.removeEventListener("boost_up", this.handleBoostUp);
            scene.removeEventListener("boost_down", this.handleBoostDown);
            this.reset();
        },
        reset() {
            this.accelerationInput.set(0, 0, 0);
            this.velocity.set(0, 0, 0);
            this.angularVelocity = 0;
            this.pendingSnapRotationMatrix.identity();
        },
        setAccelerationInput: function (event) {
            var detail;
            if (
                this.data.enabled &&
                (null === (detail = null == event ? void 0 : event.detail) ||
                void 0 === detail
                    ? void 0
                    : detail.axis)
            ) {
                this.accelerationInput.set(
                    event.detail.axis[0],
                    0,
                    event.detail.axis[1]
                );
            }
        },
        setAccelerationInputStop: function (event) {
            if (this.data.enabled && this.avatar) {
                // document.querySelector("#walk-sound").components.sound.stopSound();
            }
        },
        setAngularVelocity: function (event) {},
        snapRotateLeft: function () {
            if (this.data.enabled) {
                this.pendingSnapRotationMatrix.identity();
                this.pendingSnapRotationMatrix.copy(this.leftRotationMatrix);
            }
        },
        snapRotateRight: function () {
            if (this.data.enabled) {
                this.pendingSnapRotationMatrix.identity();
                this.pendingSnapRotationMatrix.copy(this.rightRotationMatrix);
            }
        },
        handleTeleport: function (event) {
            if (this.data.enabled) {
                this.el.object3D.position.copy(event.detail.newPosition);
                this.velocity.set(0, 0, 0);
            }
        },
        handleBoostUp: function (event) {
            if (this.data.enabled) {
                this.boost = true;
                this.data.speedMultiplier = this.data.boostMultiplier;
            }
        },
        handleBoostDown: function (event) {
            if (this.data.enabled) {
                this.boost = false;
                this.data.speedMultiplier = 1;
            }
        },
        tick: (function () {
            const translationMatrix = new THREE.Matrix4(),
                pivotPositionMatrix = new THREE.Matrix4(),
                inversePivotPositionMatrix = new THREE.Matrix4(),
                pivotPosition = new THREE.Vector3(),
                yAxis = new THREE.Vector3(0, 1, 0),
                rotationMatrix = new THREE.Matrix4(),
                objectQuaternion = new THREE.Quaternion(),
                xAxisQuaternion = new THREE.Quaternion(),
                xAxisVector = new THREE.Vector3(),
                pivotRotationMatrix = new THREE.Matrix4(),
                inversePivotRotationMatrix = new THREE.Matrix4(),
                velocityVector = new THREE.Vector3(),
                scaleVector = new THREE.Vector3(),
                vrCameraObject3D = new THREE.Object3D();

            return function (time, deltaTime) {
                const deltaTimeSec = deltaTime / 1000,
                    object3D = this.el.object3D,
                    pivotObject3D = this.data.pivot.object3D,
                    botObject3D = this.data.bot.object3D,
                    groundAcceleration = this.data.groundAcc * deltaTimeSec,
                    rotationSpeed =
                        this.data.rotationSpeed *
                        this.angularVelocity *
                        deltaTimeSec,
                    sceneEl = this.el.sceneEl;

                let cameraPose;

                if (sceneEl.is("vr-mode") && sceneEl.hasWebXR) {
                    cameraPose = sceneEl.renderer.xr.getCameraPose();
                    if (cameraPose) {
                        vrCameraObject3D.matrix.fromArray(
                            cameraPose.transform.matrix
                        );
                        vrCameraObject3D.matrix.decompose(
                            vrCameraObject3D.position,
                            vrCameraObject3D.quaternion,
                            vrCameraObject3D.scale
                        );
                    }
                }

                scaleVector.copy(object3D.scale);
                velocityVector.copy(object3D.position);
                object3D.updateMatrix();
                pivotObject3D.updateMatrix();

                pivotPosition.copy(pivotObject3D.position);
                pivotPosition.applyMatrix4(object3D.matrix);
                pivotPositionMatrix.setPosition(pivotPosition);

                inversePivotPositionMatrix.makeTranslation(
                    -pivotPosition.x,
                    -pivotPosition.y,
                    -pivotPosition.z
                );

                objectQuaternion
                    .copy(object3D.quaternion)
                    .multiply(pivotObject3D.quaternion)
                    .multiply(vrCameraObject3D.quaternion);

                xAxisVector
                    .copy(yAxis)
                    .applyQuaternion(objectQuaternion)
                    .normalize();

                xAxisQuaternion.setFromUnitVectors(xAxisVector, yAxis);
                xAxisQuaternion.multiply(objectQuaternion);

                pivotRotationMatrix.makeRotationFromQuaternion(xAxisQuaternion);
                inversePivotRotationMatrix.makeRotationFromQuaternion(
                    xAxisQuaternion.invert()
                );

                const delta = this.clock.getDelta();
                this.updateVelocity(delta, pivotObject3D);

                const boostFactor = this.boost ? 2 : 1;
                translationMatrix.makeTranslation(
                    this.velocity.x * groundAcceleration * boostFactor,
                    this.velocity.y * groundAcceleration * boostFactor,
                    this.velocity.z * groundAcceleration * boostFactor
                );

                rotationMatrix.makeRotationAxis(yAxis, rotationSpeed);

                object3D.matrix.premultiply(inversePivotPositionMatrix);
                object3D.matrix.premultiply(inversePivotRotationMatrix);
                object3D.matrix.premultiply(translationMatrix);
                object3D.matrix.premultiply(rotationMatrix);
                object3D.matrix.premultiply(this.pendingSnapRotationMatrix);
                object3D.matrix.premultiply(pivotRotationMatrix);
                object3D.matrix.premultiply(pivotPositionMatrix);

                object3D.matrix.decompose(
                    object3D.position,
                    object3D.quaternion,
                    object3D.scale
                );

                if (cameraPose) {
                    botObject3D.setRotationFromEuler(vrCameraObject3D.rotation);
                    botObject3D.rotation.x = 0;
                    botObject3D.rotation.z = 0;
                    botObject3D.position.x = vrCameraObject3D.position.x;
                    botObject3D.position.z = vrCameraObject3D.position.z;
                }

                this.pendingSnapRotationMatrix.identity();
            };
        })(),
        setPositionOnNavMesh: function (position, target, result) {},
        resetPositionOnNavMesh: function (position, target, result) {
            const navSystem = this.el.sceneEl.systems.nav;
            if (navSystem.navMesh) {
                this.navGroup = navSystem.getGroup(position);
                this.navNode =
                    navSystem.getNode(target, this.navGroup) || this.navNode;
                this.navNode = navSystem.clampStep(
                    position,
                    target,
                    this.navGroup,
                    this.navNode,
                    result.position
                );
            }
        },
        updateVelocity: function (deltaTime, pivotObject3D) {
            const data = this.data,
                velocity = this.velocity;

            if (deltaTime > 0.09) {
                velocity.x = 0;
                velocity.y = 0;
                velocity.z = 0;
                return;
            }

            if (velocity.x !== 0)
                velocity.x -= velocity.x * data.easing * deltaTime;
            if (velocity.z !== 0)
                velocity.z -= velocity.z * data.easing * deltaTime;
            if (velocity.y !== 0)
                velocity.y -= velocity.y * data.easing * deltaTime;

            const accelerationX =
                    data.groundAcc * deltaTime * this.accelerationInput.x,
                accelerationZ =
                    data.groundAcc * deltaTime * -this.accelerationInput.z;

            velocity.x += accelerationX;

            if (this.data.fly) {
                const pivotRotationRatio = pivotObject3D.rotation.x / n;
                velocity.y += accelerationZ * -pivotRotationRatio;
                velocity.z += accelerationZ * (1 - pivotRotationRatio);
            } else {
                velocity.z += accelerationZ;
            }

            this.accelerationInput.x *= 0.7;
            this.accelerationInput.z *= 0.7;

            const threshold = 0.001;

            if (Math.abs(velocity.x) < threshold) velocity.x = 0;
            if (Math.abs(velocity.y) < threshold) velocity.y = 0;
            if (Math.abs(velocity.z) < threshold) velocity.z = 0;
        },
    });
});
